import dayjs from 'dayjs';
import React from 'react';

import IsBlocked from '@/core/components/IsBlocked';
import Link from '@/core/components/Link';
import ProfileInfo from '@/core/components/ProfileInfo';
import type UserDomain from '@/core/lib/new-architecture/domain/user.domain';
import Routes from '@/core/lib/router/routes';
import { useTranslationContext } from '@/core/lib/translation/translation.context';

dayjs.locale('fr');

interface ProfileDetailsProps {
  user: UserDomain;
}

const ProfileDetails: React.FC<ProfileDetailsProps> = ({ user }) => {
  const { t } = useTranslationContext(['common']);

  const { donationDonated, donationReceived } = user.getPublicInfo();
  const isPrivate = user.isPrivate();

  return (
    <article className="mt-4 flex w-full flex-col justify-between space-y-4 lg:space-y-7 lg:px-25">
      <ProfileInfo user={user} hasH1 />

      <section className="grid grid-cols-12 content-center gap-3">
        <div className="col-span-6 rounded-3 bg-bg-pale py-3 text-center">
          <p className="text-heading font-bold text-content-primary">{donationDonated}</p>
          <p className="text-body-secondary font-medium text-content-primary">
            {donationDonated > 1 ? t('components.profile.public.sends', { ns: 'common' }) : t('components.profile.public.send', { ns: 'common' })}
          </p>
        </div>
        <div className="col-span-6 rounded-3 bg-bg-pale py-3 text-center">
          <p className="text-heading font-bold text-content-primary">{donationReceived}</p>
          <p className="text-body-secondary font-medium text-content-primary">
            {donationReceived > 1 ? t('components.profile.public.takes', { ns: 'common' }) : t('components.profile.public.take', { ns: 'common' })}
          </p>
        </div>
      </section>

      {user.isBlocked() && <IsBlocked />}

      {isPrivate && (
        <section className="w-full">
          <Link href={new Routes.ProfileModifyRoute()} variant="secondary" iconLeft="edit">
            {t('components.profile.public.edit', { ns: 'common' })}
          </Link>
        </section>
      )}
    </article>
  );
};

export default ProfileDetails;
